export const PAYMENT_FORM_IS_PROCESSING = 'PAYMENT_FORM_IS_PROCESSING';
export const PAYMENT_FORM_SUCCESS = 'PAYMENT_FORM_SUCCESS';
export const PAYMENT_FORM_FAILURE = 'PAYMENT_FORM_FAILURE';
